import { StorageOfUniqueServices } from '@qality/common-service';

export default function useTestCycleNavigation() {
  const navigateToTestCycle = (testCycleId: number): void => {
    const testCycleUrl =
      StorageOfUniqueServices.get('URLService').getTestCycleUrl(testCycleId);

    StorageOfUniqueServices.get('AP').navigator.go('site', {
      absoluteUrl: testCycleUrl,
    });
  };

  return { navigateToTestCycle };
}
